const translations = {
  'Language': 'Chinese',
  'Transactions': '交易',
  'Accounts': '帳戶',
  'Filter': 'Filter',
  'Status': 'Status',
  'Find': 'Find',
  'ID': 'ID',
  'Name': 'Name',
  'Phone number': 'Phone number',
  'Intrabank': '銀行內部',
  'Salaries': '薪資',
  'Statement': '提煉',
  'Interbank': '銀行同業拆借',
  'Ruble transfer': '盧布轉帳',
  'Interbank payment': 'Interbank payment',
  'SWIFT': 'SWIFT',
  'Ruble': 'Ruble',
  'Account': 'Account',
  'Search': 'Search',
  'All': 'All',
  'Sign in': 'Sign in',
  'Signing in': 'Signing in',
  'Processing': 'Processing',
  'Not successful': 'Not successful',
  'Successful': 'Successful',
  'Date': 'Date',
  'Sender': 'Sender',
  'Recipient': 'Recipient',
  'Sender account': 'Sender acccount',
  'Recipient account': 'Recipient account',
  'Transaction type': 'Transaction type',
  'Amount': 'Amount',
  'Login': 'Login',
  'Password': 'Password',
  'Sign up': 'Sign up',
  'Exchange Rates': '匯率',
  'Exchange': '轉換',
  'NBT': 'NBT',
  'Currency': '洋流',
  'Purchase': '鬥爭',
  'Sale': '銷售',
  'USD': 'USD',
  'EUR': 'EUR',
  'RUB': 'RUB',
  'All accounts': 'All accounts',
  'TJS': 'TJS',
  'Last operations': 'Last operations',
  'Between own accounts': '自有帳戶之間',
  'Intrabank payment': 'Intrabank payment',
  'MyAccounts': 'My accounts',
  'Active': 'Active',
  'Not active': 'Not active',
  'Update': 'Update',
  'Updated': '已更新',
  'Russian': 'Russian',
  'English': 'English',
  'Tajik': 'Tajik',
  'Bank accounts': 'Bank accounts',
  'Visa Business': 'Visa Business',
  'Account Information': 'Account Information',
  'File information': 'File Information',
  'Account name': 'Account name',
  'Balance': 'Balance',
  'Account type': 'Account type',
  'Address': 'Address',
  'TIN': 'TIN',
  'Date of opening': 'Date of opening',
  'Requisites': 'Requisites',
  'Download': 'Download',
  'Upload': 'Upload',
  'Upload file': '文件上傳',
  'Description': 'Description',
  'Show filters': 'Show filters',
  'No transaction': 'No transaction',
  'TxID': 'TxID',
  'Payment information': '付款資訊',
  'Commission': 'Commission',
  'Date of creation': 'Date of creation',
  'Retry payment': 'Retry payment',
  'Download PDF': 'Download PDF',
  'Authorizers': 'Authorizers',
  'Reject': 'Reject',
  'Confirm': '確認',
  'Payment Information': 'asfasfasf',
  'Bank information': 'Bank information',
  'From account': '來自帳戶',
  'To account': '就是這個帳號',
  'Transfer amount': '轉帳金額',
  'Narrative': '敘述',
  'Existing template': 'Existing template',
  'Sender information': 'Sender information',
  'Recipient information': 'Recipient information',
  'Account number': 'Account number',
  'Confirm account number': 'Confirm account number',
  'Payment details': 'Payment details',
  'Other details': 'Other details',
  'Document type': 'Document type',
  'Document number': 'Document number',
  'Document date': 'Document date',
  'Save template': 'Save template',
  'Country': 'Country',
  'City': 'City',
  'Enter amount': '輸入金額',
  'Document': 'Document',
  'Enter document number': 'Enter document number',
  'Initiator': 'Initiator',
  'Number of transactions': 'Number of transactions',
  'Import': 'Import',
  'Rejected': 'Rejected',
  'Importing payments from a file': 'Importing payments from a file',
  'Download document': 'Download document',
  'Salary project': 'Salary project',
  'Select account': '選擇帳戶',
  'Select date': 'Select date',
  'Order an statement': 'Order an statement',
  'View orders': 'View orders',
  'Ordering a statement': 'Ordering a statement',
  'Enter the title': 'Enter the title',
  'Order': 'Order',
  'Ready': 'Ready',
  'Failed': 'Failed',
  'In progress': 'In progress',
  'Period': 'Period',
  'Orders': 'Orders',
  'Tariffs': 'Tariffs',
  'Transfer between own accounts': 'Transfer between own accounts',
  'Show all currencies': 'Show all currencies',
  'Rate': 'Rate',
  'Currency сode': 'Currency сode',
  'Unit': 'Unit',
  'No.': 'No.',
  'Change Password': 'Change Password',
  'Log out': 'Log out',
  'Profile': 'Profile',
  'Enter a new password': 'Enter a new password',
  'Enter old password': 'Enter old password',
  'Change': 'Change',
  'Contacts': 'Contacts',
  'oriyon-business@oriyonbonk.tj': 'oriyon-business@oriyonbonk.tj',
  'Call center 2222': 'Call center 2222',
  'Loans': 'Loans',
  'Deposits': 'Deposits',
  'OtpCode': 'Confirmation code',
  'ResendTime': 'Resending will be available via',
  'Second': 'second',
  'ResendCode': 'Resend code',
  'Save': 'Save',
  'All operations': 'All operations',
  'Operation': 'Operation',
  'No Transactions': 'No Transactions',
  'Payments': '付款方式',
  'More': '更多的',
  'Notifications': '通知',
  'No notifications': '没有通知',
  'New': '新的',
  'CurrienciesToSomoni': 'Official exchange rate of currencies against Somoni:',
  'Hide all currencies': 'Hide all currencies',
  'ToSign': 'To sign',
  'Rejecteds': 'Rejected',
  'Enter Recipient Account': 'Enter Recipient Account',
  'Confirm payment': 'Confirm payment',
  'Payment type': 'Payment type',
  'Enter Recipient': 'Enter Recipient',
  'Enter TIN': 'Введите TIN',
  'Enter template name': 'Enter template name',
  'Recipient TIN': 'Recipient TIN',
  'Show balance': 'Show balance',
  'Hide balance': 'Hide balance',
  'Hide filters': 'Hide filters',
  'Swift': '貨幣轉帳',
  'Bank name': 'Bank name',
  'Filters': 'Filters',
  'Show': 'Show',
  'Select template': 'Select template',
  'One Dollar': '1 Dollar',
  'One Ruble': '1 Ruble',
  'One Euro': '1 Euro',
  'Orienbank Address': 'Dushanbe, Rudaki Avenue 95/1',
  'Enter City': 'Enter City',
  'Enter Country': 'Enter Country',
  'Enter Address': 'Enter Address',
  'Enter Account': 'Enter Account',
  'Enter swift code': 'Enter swift code',
  'Enter bank name': 'Enter bank name',
  'Enter doc number': 'Enter doc number',
  'Enter SMS code': 'Enter SMS code',
  'Find swift code': 'Find swift code',
  'Required': 'Required',
  'Enter symbol only': 'Enter symbol only',
  'Amount must be more 1': 'Amount must be more 1',
  'Wrong amount': 'Wrong amount',
  'Latin Only': 'Latin Only',
  'Account does not match': 'Account does not match!',
  'Account must contain no more than 20 digits': 'Account must contain no more than 20 digits',
  'Account must contain at least 20 digits': 'Account must contain at least 20 digits',
  'Enter number only': 'Enter number only',
  'ConfirmSmsFromPhone': 'To confirm the transaction, an SMS code has been sent to your phone number',
  'No accounts': 'No accounts',
  'Account does not found': 'Account does not found!',
  'Must be 9 numbers': 'Must be 9 numbers',
  'Enter': 'Enter',
  'Field must contain at least 8 digits': 'Field must contain at least 8 digits!',
  'For registration':
    'To register in the Internet Banking system, you need to contact the central office of Orienbank, at',
  'For any questions': 'For any questions, please contact our contact center, we will be happy to help you',
  'Code': 'Code',
  'Sent code to phone for sequirity': 'To protect your profile, we will send a verification code to your phone number',
  'Change your password': 'Change your password',
  'Password does not match': 'Password does not match',
  'Confirm password': 'Confirm password',
  'Change and remind password': 'Change and remember the password that is more convenient for you',
  'International': '貨幣轉帳',
  'File date': 'File date',
  'Total amount': 'Маблаг',
  'Debit': 'Debit',
  'Credit': 'Debit',
  'Own accounts payments': 'Own accounts payments',
  'Intrabank payments': 'Intrabank payments',
  'Interbank payments': 'Interbank payments',
  'Successful count': 'Successful count',
  'Not successful count': 'Not successful count',
  'Download file': 'Download file',
  'Error': 'Error',
  'Transaction list': 'Transaction list',
  'Branch': 'Branch',
  'Approved': 'Approved',
  'From amount': 'From amount',
  'To amount': 'To amount',
  'Start date': 'Start date',
  'End date': 'End date',
  'No data': 'No data',
  'Enter document type': 'Enter document type',
  'In confirmation': 'In confirmation',
  'In verification': 'In verification',
  'Partial success': 'Partial success',
  'Download salary file template': 'Download salary file template',
  'Upload document': 'Upload document',
  'The file format must be xlsx, xls': 'The file format must be xlsx, xls',
  'The file format must be txt': 'The file format must be txt',
  'The file size should not exceed 2MB': 'The file size should not exceed 2MB',
  'Wrong file format': '文件格式错误',
  'File is too large': '文件过大',
  'FIO': 'Full name',
  'Company name': 'Company name',
  'International payment': 'International payment',
  'Transaction date': 'Transaction date',
  'Back': 'Back',
  'Repeat': 'Repeat',
  'Urgent': 'Urgent',
  'Edit account name': 'Edit account name',
  'Maximum number of characters: 70': 'Maximum number of characters: 70',
  'Confirm new password': 'Confirm new password',
  'Exit': 'Exit',
  'security': {
    'title': 'Your business security: how to avoid falling for fraudsters',
    'sectionPrefix': 'Section',
    'section1Title': 'Verifying request authenticity',
    'section1Subtitle': 'Your basic security rules for communication.',
    'section2Title': 'Business compliance security',
    'section2Subtitle': 'Recommendations to protect the company from account blocks and legal risks.',
    'labelAction': 'Action',
    'labelConsequence': 'Consequence',
    'labelRule': 'Rule',
    'labelRisk': 'Risk',
    'labelCheck': 'Control point',
    's1i1Title': '"Urgent request from a manager"',
    's1i1Text':
      'If you receive a messenger or email request from your director asking you to urgently transfer money to new bank details — this is a red flag. Fraudsters can imitate communication style and even voice.',
    's1i1Action': 'Always call the manager back on a regular phone number and confirm the order in person.',
    's1i2Title': '"Fake tech support"',
    's1i2Text':
      'Calls from "bank employees" asking you to install AnyDesk, RustDesk or TeamViewer to "set up the system".',
    's1i2Action': 'Hang up immediately. The bank never requires the installation of remote access programs.',
    's1i3Title': 'Number spoofing',
    's1i3Text': "Fraudsters use technology to display the Bank's official number on your mobile phone screen.",
    's1i3Action':
      'If they ask you for SMS codes or passwords — end the call and dial the bank yourself using the number on the official website.',
    's2i1Title': '"Transit" risk (AML/CFT)',
    's2i1Text': 'You receive an "accidental" payment and are asked to return it — but to different details or in cash.',
    's2i1Consequence':
      'You become a link in a money laundering chain, which leads to all company accounts being blocked.',
    's2i1Rule': 'Return funds only based on an official letter and only to the account from which the money was sent.',
    's2i2Title': 'Sanctions traps',
    's2i2Text':
      'The counterparty offers complex payment schemes through a chain of intermediaries or to third-party accounts.',
    's2i2Risk':
      'Violation of international sanctions, which may deprive the bank and your company of access to currency operations.',
    's2i3Title': 'Fictitious services',
    's2i3Text':
      'Payment for marketing, consulting or IT services to companies without staff, office or operational history.',
    's2i3Check':
      'The bank verifies the reality of operations. Working with shell companies is a sign of fund withdrawal.',
    'alertTitle': 'If you suspect fraud:',
    'alertStep1': 'Turn off the internet on your computer (unplug the cable).',
    'alertStep2Prefix': 'Call the Bank at:',
  },
};

export default translations;
